import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Row, Col } from 'antd';

const JobDetailsHeader = ({ title, seniority }) => {
  return (
    <Row>
      <Col><Typography.Text className="job-details-header">{title}</Typography.Text></Col>
      {/* <Col style={{ marginTop: '8px' }}><Typography.Text className="job-details-seniority">{seniority}</Typography.Text></Col> */}
    </Row>
  );
};

JobDetailsHeader.propTypes = {
  title: PropTypes.string,
  seniority: PropTypes.string
};

export default JobDetailsHeader;
